export default __webpack_public_path__ + "static/media/img_scsc_12.74c8880f.png";